export default __webpack_public_path__ + "static/media/handshake.a7cf856a.png";